/** Integer-only helpers. Millipoints: 1000 === 1.0 */

export type Milli = number;

export function clampMilli(value: number, min = 0, max = 100_000): Milli {
  if (value < min) return min;
  if (value > max) return max;
  return value | 0;
}

export function mulMilli(a: Milli, b: Milli): Milli {
  // (a * b) / 1000 with integer truncation toward zero.
  return ((a * b) / 1000) | 0;
}

export function addMilli(...values: Milli[]): Milli {
  let sum = 0;
  for (const v of values) sum += v;
  return sum | 0;
}

/**
 * Deterministic mulberry32 PRNG. Returns millipoints in [0, 1000).
 * Seeded randomness only — never Date.now or Math.random.
 */
export function createSeededRng(seed: number): () => Milli {
  let state = seed | 0;
  return () => {
    state = (state + 0x6d2b79f5) | 0;
    let t = Math.imul(state ^ (state >>> 15), 1 | state);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    const u = ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    return (u * 1000) | 0;
  };
}
